/**
 * A screen's heading, and the two states that are not the screen.
 *
 * A failure prints what the server said, because those messages name the thing that was wrong.
 * Nothing here invents a placeholder number while it waits — an empty rule bar is a lie of the
 * same kind as a rounded rate.
 */

import type { ReactNode } from "react";

export function Kicker({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-quiet">
      {children}
    </div>
  );
}

export function Loading({ what }: { what: string }): JSX.Element {
  return (
    <p className="py-10 font-mono text-sm text-ink-quiet" role="status">
      Reading {what}…
    </p>
  );
}

export function Failed({ error }: { error: string }): JSX.Element {
  return (
    <div className="my-8 rounded-xl border border-fault/40 bg-fault/5 p-5" role="alert">
      <div className="font-mono text-[11px] uppercase tracking-[0.14em] text-fault-strong">
        The pipeline did not answer
      </div>
      <p className="mt-2 text-sm leading-relaxed text-ink-faded">{error}</p>
    </div>
  );
}

/** A note explaining why a corpus-wide number is missing, printed instead of inventing one. */
export function Note({ children }: { children: ReactNode }): JSX.Element {
  return (
    <p className="mt-4 rounded-xl border border-departure bg-departure/40 px-4 py-3 text-xs leading-relaxed text-departure-ink">
      {children}
    </p>
  );
}
